import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FaHome, FaUser, FaUsers, FaFileContract, FaGavel, FaMoneyBill, FaHourglassStart, FaLock } from 'react-icons/fa';
import { MdClose } from "react-icons/md";
import { useSelector } from 'react-redux';
import useMembershipStatus from '../../../useMemberShipStatus';

const CompanySidebar = ({ isOpen, toggleSidebar }) => {
  useMembershipStatus();
  const { membershipStatus } = useSelector((state) => state.auth);
  const location = useLocation(); // Get current route

  const companyLinks = [
    { path: "/", label: "Home", icon: <FaHome /> },
    { path: "/dashboard/company", label: "Dashboard", icon: <FaHourglassStart /> },
    { path: "/dashboard/company/profile", label: "Profile", icon: <FaUser /> },
    { path: "/dashboard/company/users", label: "Users", icon: <FaUsers /> },
    { path: "/dashboard/company/suppliers", label: "Suppliers", icon: <FaUsers /> },
    { path: "/dashboard/company/tenders", label: "Tenders", icon: <FaFileContract /> },
    { path: "/dashboard/company/bidding", label: "Bidding", icon: <FaGavel /> },
    { path: "/dashboard/company/payments", label: "Payments", icon: <FaMoneyBill /> },
  ];

  const isLinkDisabled = (label) => {
    if (membershipStatus === 'inactive') {
      return !['Home', 'Dashboard', 'Profile', 'Payments'].includes(label);
    }
    return false;
  };

  return (
    <div
      className={`p-6 fixed lg:static top-0 left-0 w-64 bg-gradient-to-br from-blue-200 to-green-300 text-gray-900
        transition-transform duration-300 lg:translate-x-0 z-50 shadow-2xl shadow-blue-400/50 min-h-screen
        ${isOpen ? "translate-x-0" : "-translate-x-full"}
      `}
    >
      {/* Close button for mobile */}
      <button className="lg:hidden text-gray-900 mb-4" onClick={toggleSidebar}>
        <MdClose size={24} />
      </button>

      <h2 className="text-2xl font-bold mb-6 text-blue-800">NGO Menu</h2>

      <nav className="space-y-4">
        {companyLinks.map(({ path, label, icon }) => {
          const isDisabled = isLinkDisabled(label);
          const isActive = location.pathname === path;

          return (
            <Link
              key={path}
              to={isDisabled ? "#" : path}
              className={`flex items-center space-x-3 px-5 py-3 rounded-lg text-lg font-semibold
                transition-all duration-300 shadow-md
                ${
                  isActive
                    ? "bg-green-500 text-white shadow-lg scale-105"
                    : "bg-white text-gray-900 hover:bg-blue-500 hover:text-white"
                }
                ${isDisabled ? "cursor-not-allowed bg-gray-400 text-gray-600" : ""}
              `}
              onClick={isDisabled ? (e) => e.preventDefault() : toggleSidebar}
            >
              {isDisabled && <FaLock className="mr-2 text-gray-600" />}
              {icon}
              <span>{label}</span>
            </Link>
          );
        })}
      </nav>
    </div>
  );
};

export default CompanySidebar;
